import React from "react";
import styled from "@mui/system/styled";

import { SVGArrow } from "../../svgs";
import { ISortBy } from "../../../types";

interface Props {
  sortBy: ISortBy;
  by: string;
  invert?: boolean;
}

const IconContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  pointerEvents: "none",
});

const SortArrow: React.FC<Props> = ({ sortBy, by, invert }) => {
  let { order } = sortBy;
  if (invert) {
    order = !sortBy.order;
  }

  if (sortBy.by === by) {
    return order ? (
      <IconContainer>
        <SVGArrow rotate="90deg" r="3" />
      </IconContainer>
    ) : (
      <IconContainer>
        <SVGArrow rotate="-90deg" r="3" />
      </IconContainer>
    );
  }
  return null;
};

export default SortArrow;
